import { createElement, memo } from 'react';
import classnames from 'classnames/bind';
import { EColors } from '@/_types';
import { ETextSize } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Text';

type TProps = {
  text: string;
  color?: EColors;
  size: ETextSize;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p';
  align?: 'center';
  variant:
    | 'body'
    | 'display'
    | 'display-accent'
    | 'display-accent-compact'
    | 'display-compact'
    | 'description'
    | 'description-compact'
    | 'description-georgian'
    | 'span-description'
    | 'span-description-strong'
    | 'stat-body'
    | 'stat-body-georgian'
    | 'stat-body-strong'
    | 'headline'
    | 'title';
  bold?: boolean;
  italic?: boolean;
};

export const Text = memo(function TextComponent({
  text,
  color,
  size,
  align,
  as = 'p',
  variant,
  bold = false,
  italic = false,
}: TProps) {
  return createElement(
    as,
    {
      className: cn(BLOCK_NAME, `${BLOCK_NAME}--${variant}-${size}`, {
        [`${BLOCK_NAME}--${color}`]: color,
        [`${BLOCK_NAME}--${align}`]: align,
        [`${BLOCK_NAME}--bold`]: bold,
        [`${BLOCK_NAME}--italic`]: italic,
      }),
    },
    text,
  );
});
